'use client'

import * as React from 'react'

import * as TabsPrimitive from '@radix-ui/react-tabs'

import { cn } from '~/utils/tailwind-utils'

export const TabsList = ({
  ref,
  variant = 'default',
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsPrimitive.List> & {
  ref?: React.RefObject<React.ElementRef<typeof TabsPrimitive.List> | null>
  variant?: 'default' | 'table'
}) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'flex items-center space-x-6',
      variant === 'default' && 'border-b border-gray-200 dark:border-gray-700',
      variant === 'table' && 'sticky left-0 w-fit pl-4 md:pl-6 lg:pl-8',
      className,
    )}
    {...props}
  />
)
